<template>
    <div class="alldetails">
        <div class="card p-4 pl-lg-5" v-if="experienceList.length > 0">
            <span class="fontsizemd proximanova black stylebold">Work Experience</span>
            <div v-for="(exp, index) in experienceList" :key="index">
                <div class="d-flex mt-3">
                    <div class="col-1 pl-0 pr-0">
                        <img src="../../../assets/Company_Icon.svg" class="img-fluid compIcon border borderradiushalf rounded-circle" alt="companylogo">
                    </div>
                    <div class="d-flex flex-column ml-3">
                        <div class="fontsizemd black stylebold proximanova">{{exp.companyDetails.companyName}}</div>
                        <div class="fontsizemd black60 proximanova text-capitalize">
                            {{exp.userRoles.roleName}} - {{exp.employeementTypeString}}
                        </div>
                        <div class="d-flex fontsize12 black30 proximanova stylebold">
                            <div v-if="exp.startDate">{{exp.startDate | moment("MMM YYYY") }}</div> <span class="pl-lg-2 pr-lg-2 pr-1 pl-1"> - </span> 
                            <div v-if="exp.endDate">{{exp.endDate | moment("MMM YYYY")}}</div>
                            <div v-if="exp.currentWorkingFlag == 'Y'">Present</div> <span class="pr-lg-2 pr-1"> , </span>
                            <div v-if="exp.totalExperience && exp.currentWorkingFlag == 'N'">{{exp.totalExperience}}</div>
                            <div v-else>{{new Date(exp.startDate) | moment("from", "now", true)}}</div>
                        </div>
                        <div class="proximanova-semibold fontsize12 black30  text-capitalize d-flex">
                            <span v-if="exp.city" class="mr-1">{{exp.city.cityName}} ,</span><span v-if="exp.country">{{exp.country.countryName}}</span>
                        </div>
                        <div class="d-flex flex-nowrap mt-2 pr-4 mb-3" v-if="exp.description">
                            <div class="fontsize14 black60 proximanova">
                                <span >{{exp.description1}} </span>
                                <span class="proximanova fontsize14 blue pointer readmorelink" :id="'readmore'+index" v-if="exp.description2.length>0" @click="readMoreExp">...readmore</span>
                                <span class="proximanova fontsize14 blue pointer readlesslink" :id="'readless'+index" @click="readLessExp">...readless</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card p-4 pl-lg-5 mt-2" v-if="educationList.length > 0">
            <span class="fontsizemd proximanova black stylebold">Education</span>
            <div v-for="(edu, index) in educationList" :key="index">
                <div class="d-flex mt-3">
                    <div class="col-1 pl-0 pr-0">
                        <img src="../../../assets/Company_Icon.svg" class="img-fluid compIcon1 border borderradiushalf rounded-circle" alt="companylogo">
                    </div>
                    <div class="d-flex flex-column ml-3">
                        <div class="fontsizemd black stylebold proximanova" v-if="edu.instituteDetails"> {{edu.instituteDetails.instituteName}}</div>
                        <div class="fontsizemd black60 proximanova text-capitalize" v-if="edu.fieldOfStudy">{{edu.fieldOfStudy.fieldName}}</div>
                        <div class="d-flex fontsize12 black30 proximanova stylebold">
                            <div v-if="edu.fromDate">{{edu.fromDate | moment("MMM YYYY") }}</div> <span class="pl-lg-2 pr-lg-2 pl-1 pr-1"> - </span> 
                            <div v-if="edu.toDate">{{edu.toDate | moment("MMM YYYY")}}</div>
                            <div v-if="edu.currentStudyFlag == 'Y'">Present</div> <span class="pr-lg-2 pr-1"> , </span>
                            <div v-if="edu.educationDuration">{{edu.educationDuration}}</div>
                            <div v-else>{{new Date(edu.fromDate) | moment("from", "now", true)}}</div>
                        </div>
                        <div class="proximanova fontsize14 black30  text-capitalize d-flex">
                            <span v-if="edu.city" class="mr-1">{{edu.city.cityName}} , </span> <span v-if="edu.country">{{edu.country.countryName}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card p-4 pl-lg-5 mt-2" v-if="jobApplicantDetails.country && jobApplicantDetails.state && jobApplicantDetails.city">
            <span class="fontsizemd proximanova black stylebold">Current Location</span>
            <div class="d-flex mt-3">
                <div class="col-1 pl-0 pr-0">
                    <img src="../../../assets/Company_Icon.svg" class="img-fluid compIcon1 border borderradiushalf rounded-circle" alt="logo">
                </div>
                <div class="d-flex flex-column ml-3">
                    <div class="fontsizemd black stylebold proximanova" v-if="jobApplicantDetails.country">{{jobApplicantDetails.country.countryName}}</div>
                    <div class="fontsizemd black60 proximanova text-capitalize" v-if="jobApplicantDetails.state">{{jobApplicantDetails.state.stateName}}</div>
                    <div class="d-flex fontsize12 black30 proximanova stylebold" v-if="jobApplicantDetails.city">{{jobApplicantDetails.city.cityName}}, {{jobApplicantDetails.zipCode}}</div>
                </div>
            </div>
        </div>
        <div class="card p-4 pl-lg-5 mt-2" v-if="Tools.length > 0 || skillsList.length > 0">
            <span class="fontsizemd proximanova black stylebold">Skills</span>
            <span class="fontsizemd black60 proximanova mt-3 stylebold" v-if="skillsList.length > 0">Knowledge In</span>
            <div v-if="skillsList.length > 0" class="d-flex flex-wrap mt-2" >
                <div v-for="(skill, index) in skillsList" :key="index" >
                    <div class="pl-3 pr-3 mr-2 p-1  fontsize12 backgroundcolor2 black60 borderadius12 pb-1 borderadius12 proximanova d-flex mt-1">
                        {{skill.knowledgeDetails.knowledgeIn}}
                    </div>
                </div>
            </div>
            <span class="fontsizemd black60 proximanova mt-4 stylebold" v-if="Tools.length > 0">Tools</span>
            <div v-if="Tools.length > 0" class="d-flex flex-wrap mt-2" >
                <div v-for="(tool, index) in Tools" :key="index" >
                    <div class="pl-3 pr-3 mr-2 p-1  fontsize12 backgroundcolor2 black60 borderadius12 pb-1 borderadius12 proximanova d-flex mt-1">
                        {{tool.technologyDetails.technologyName}}
                    </div>
                </div>
            </div>
        </div>
        <div class="card p-4 pl-lg-5 mt-2" v-if="Tools.length < 1 && skillsList.length < 1 && educationList.length < 1 && experienceList.length < 1">
            <div class="mt-5 mb-5 ml-3 mx-auto">
                <span class="proximanova-bold fontsize16 black60">No Details Found</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props : [
        'jobApplicantDetails'
    ],
    data() {
        return{
            experienceList : [],
            educationList : [],
            skillsList : [],
            Tools : []
        }
    },
    mounted(){
        this.experienceList = this.jobApplicantDetails.workExperience;
        this.educationList = this.jobApplicantDetails.userEducation;
        this.skillsList = this.jobApplicantDetails.userKnowledge;
        this.Tools = this.jobApplicantDetails.userTechnology;
    },
    methods : {
        readMoreExp  :function(event) {
            let index = event.target.id.substr(8)
            this.experienceList[index].description1 = this.experienceList[index].description1.concat(this.experienceList[index].description2)
            let relessId = "readless"+index
            document.getElementById(relessId).style.display = 'inline-block'
            document.getElementById(event.target.id).style.display = 'none'
        },
        readLessExp : function(event) {
            let index = event.target.id.substr(8)
            this.experienceList[index].description1 = this.experienceList[index].description1.substr(0, 196)
            let remoreId = "readmore"+index
            document.getElementById(remoreId).style.display = 'inline-block'
            document.getElementById(event.target.id).style.display = 'none'
        },
    }
}
</script>
<style scoped>
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.compIcon {
  width: 50px;
}
.compIcon1{
    width: 50px;
}
.readlesslink {
  display: none;
}
</style>